import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

const TRENDING_EXPERIENCES = [
  {
    id: 1,
    title: "Melbourne Food & Laneway Tour",
    location: "Melbourne, Australia",
    price: "From AUD 89",
    rating: "4.98",
    reviews: "120",
    slug: "melbourne-food-laneway-tour-1",
    img: "https://images.unsplash.com/photo-1514395462725-fb4566210144?auto=format&fit=crop&w=800&q=80",
    category: "food-drink",
  },
  {
    id: 2,
    title: "Blue Mountains Day Adventure",
    location: "Sydney, Australia",
    price: "From AUD 129",
    rating: "4.95",
    reviews: "98",
    slug: "blue-mountains-day-adventure-2",
    img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=800&q=80",
    category: "adventure",
  },
  {
    id: 3,
    title: "Yarra Valley Wine Tasting Tour",
    location: "Melbourne, Australia",
    price: "From AUD 149",
    rating: "4.92",
    reviews: "85",
    slug: "yarra-valley-wine-tasting-tour-3",
    img: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=800&q=80",
    category: "food-drink",
  },
  {
    id: 4,
    title: "Great Barrier Reef Snorkeling",
    location: "Cairns, Australia",
    price: "From AUD 199",
    rating: "4.97",
    reviews: "142",
    slug: "great-barrier-reef-snorkeling-4",
    img: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=800&q=80",
    category: "water",
  },
  {
    id: 5,
    title: "Sydney Harbour Cruise",
    location: "Sydney, Australia",
    price: "From AUD 99",
    rating: "4.90",
    reviews: "76",
    slug: "sydney-harbour-cruise-5",
    img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?auto=format&fit=crop&w=800&q=80",
    category: "water",
  },
];

function TrendingV1({ selectedCategory = "all" }) {
  const scrollRef = useRef(null);
  const [wishlist, setWishlist] = useState({});

  const toggleWishlist = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    setWishlist((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "next" ? 340 : -340;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const filteredList =
    selectedCategory === "all"
      ? TRENDING_EXPERIENCES
      : TRENDING_EXPERIENCES.filter((item) => item.category === selectedCategory);

  const displayList = filteredList.length > 0 ? filteredList : TRENDING_EXPERIENCES;

  return (
    <section className="v1-trending-section">
      <div className="v1-section-header">
        <div className="v1-section-title-box">
          <h2 className="v1-section-title">Trending Experiences</h2>
          <p className="v1-section-subtitle">
            Most-booked and top-rated adventures by travelers this week.
          </p>
        </div>

        <div className="v1-section-controls">
          <Link to="/experiences" className="v1-link-view-all">
            <span>View all</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>

          <button
            type="button"
            className="v1-slider-nav-btn"
            onClick={() => handleScroll("prev")}
            aria-label="Previous experiences"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>

          <button
            type="button"
            className="v1-slider-nav-btn"
            onClick={() => handleScroll("next")}
            aria-label="Next experiences"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>

      <div className="v1-carousel-track-wrapper">
        <div className="v1-carousel-track" ref={scrollRef}>
          {displayList.map((item) => (
            <Link
              key={item.id}
              to={`/experience/${item.slug}`}
              className="v1-exp-card"
            >
              <img
                src={item.img}
                alt={item.title}
                className="v1-exp-card-img"
                loading="lazy"
              />
              <div className="v1-exp-card-overlay"></div>

              {/* Wishlist toggle */}
              <button
                type="button"
                className={`v1-wishlist-btn ${wishlist[item.id] ? "active" : ""}`}
                onClick={(e) => toggleWishlist(e, item.id)}
                aria-label="Save to wishlist"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill={wishlist[item.id] ? "#EF4444" : "none"}
                  stroke={wishlist[item.id] ? "#EF4444" : "#111A2E"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
              </button>

              <div className="v1-exp-card-content">
                {/* Rating */}
                <div className="v1-exp-rating-row">
                  <svg
                    className="v1-star-icon"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="currentColor"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <span className="v1-exp-rating-score">{item.rating}</span>
                  <span className="v1-exp-rating-count">({item.reviews})</span>
                </div>

                <h3 className="v1-exp-card-title">{item.title}</h3>
                <p className="v1-exp-card-location">{item.location}</p>
                <p className="v1-exp-card-price">{item.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrendingV1;
